// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"28b5f886","825":"764dd564"}[chunkId] + ".chunk.css";
};